import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';
import { rtkAppRetry } from '#store/apiRetry.ts';

export const TAGS = {
    BOOKING: 'BOOKING',
};
export const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_ORDERCOM_BOOKING_API,
    prepareHeaders,
});

export const apiBooking = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiBooking',
    baseQuery: rtkAppRetry(customFetchBaseQuery),
    endpoints: () => ({}),
});
